import { get } from "../utils/request";

export const getUserScope = (serviceId) => {
  return get(`/v1/scopes`);
}